export default {
  login: {
    getpwdtitle: '找回密码',
    title: '系统登录',
    logIn: '登录',
    username: '账号',
    password: '密码',
    any: '随便填',
    opt: 'OPT登录',
    verifycode: '验证码'
  },
  payorder: {
    type: '支付类型',
    status: '状态',
    outtradeno: '订单号',
    mobile: '手机号',
    username: '姓名',
    paydate: '支付时间',
    price: '金额',
    remark: '备注',
  },
  usercard: { 
    errorrecord: '异常记录',
    categoryname: '卡类型',
    categoryid: '卡类型',
    remark: '备注',
    add: '新增',
    edit: '修改',
    delete: '删除',
    typeid: '卡类型',
    estateid: '所属小区',
    username: '用户',
    mobile: '手机',
    levelid: '优先级别',
    startdate: '开始日期',
    enddate: '截止日期',
    usedate: '使用日期',
    isvalid: '是否有效',
    cardsn: '卡号',
    isshare: '是否分享',
    outtradeno: '订单单号',
    num: '张数',
    flowsn: '流水号'
  },
  cardtype: {
    subtitle: '副标题',
    tiptitle: '广告语',
    ordersn: '排序号',
    add: '新增',
    edit: '修改',
    delete: '删除',
    typeid: '卡类型',
    levelid: '优先级别',
    title: '标题',
    detail: '详细描述',
    price: '价格',
    num: '张数',
    days: '天数',
    estateid: '所属小区',
    imagetype: '图片首字母',
    ishot: '爆款'
  },
  plan: {
    add: '新增',
    edit: '修改',
    delete: '删除',
    schedulingid: '班次',
    year: '年',
    month: '月',
    schedulingname: '班次',
    usernum: '人数',
    status: '状态',
    date: '日期',
    roomname: '所属部门(班级)',
    username: '姓名'
  },
  handsign: {
    add: '新增',
    edit: '修改',
    delete: '删除',
    roomname: '所属部门(班级)',
    roomid: '所属部门(班级)',
    uid: '姓名',
    username: '姓名',  
    signtime: '签到时间', 
    remark: '备注',
  },
  offduty: {
    add: '新增',
    edit: '修改',
    delete: '删除',
    roomname: '所属部门(班级)',
    roomid: '所属部门(班级)',
    uid: '姓名',
    username: '姓名',
    typeid: '离岗类型',
    typename: '离岗类型',
    starttime: '开始时间',
    endtime: '结束时间',
    remark: '备注',
  },
  scheduling: {
    add: '新增',
    edit: '修改',
    delete: '删除',
    schedulingname: '班次',
    starttime: '上班时间',
    endtime: '下班时间',
    startsignin: '开始签到时间',
    endsignin: '结束签到时间',
    startsignout: '开始签退时间',
    endsignout: '结束签退时间',
  },
  report: {
    reportid: '统计范围',
    username: '姓名',
    mobile: '手机号',
    devicename: '设备名称',
    keysn: '卡号',
    usedtime: '刷卡时间',
    registerdate: '注册时间',
    roomcode: '房号',
    buildname: '所属楼宇',
    floorname: '所属楼层',
    roomname: '房名',
    date: '日期',
    estatename: '社区名称',
  },
  changepwd: {
    oldpwd: '原密码',
    tipoldpwd: '请输入原密码',
    newpwd: '新密码',
    tipnewpwd: '请输入新密码',
    renewpwd: '重复密码',
    tiprenewpwd: '新重复输入密码',
    pwdstrong: '密码强度'
  },
  userblack: {
    blackdata: '内容',
    typeid: '类型',
    cda: '新增时间',
    mda: '修改时间',
    times: '累计次数',
    isblack: '是否生效'
  },
  talkbackdevice: { 
    typename: '类型',
    brandname: '所属品牌',
    doorname: '所属门(闸)',
    position: '所属位置',
    typeid: '类型',
    add: '新增',
    edit: '修改',
    delete: '删除',
    isvalid: '是否有效',
    cda: '创建时间',
    mda: '修改时间',
    devicename: '设备名称',
    version: '版本号',
    serialnumber: '序列号',
    fps: '视频帧率',
    videowidth: '视频宽',
    videoheight: '视频高',
    bitrate: '比特率',
    codec: '编码格式',
    audio: '音频',
    buildid: '所属楼宇',
  },
  event: {
    date: '上线时间',
    title: '功能',
    desc: '介绍'
  },
  vkeybase: {
    usedtime: '刷卡时间',
    keysn: '卡号',
    cardtypeid: '卡类型',
    keytypeid: '卡类',
    status: '状态',
    devicegroup: '权限组',
    validdate: '有效时间',
    idcard: 'ID卡',
    avatar: '人脸',
    collecting: '',
    vein: '静脉',
    finger: '指纹',
    iccard: 'IC卡',
    messages: '结果',
    username: '用户名',
    mobile: '手机号',
    isvalid: '状态',
    liftusedtimes: '电梯使用次数',
    doortusedtimes: '门(闸)使用次数',
  },
  control: {
    title: '远程控制',
    devicename: '设备名称',
    address: '设备地址',
    floors: '所属楼层',
    doors: '所属门(闸)',
    delay: '时长',
  },
  devicegroupdetail: {
    issystem: '来源',
    title: '权限组明细设置',
    add: '新增',
    edit: '修改',
    delete: '删除',
    cda: '创建时间',
    mda: '修改时间',
    buildid: '所属楼宇',
    timeslot: '所属时段',
    floors: '所属楼层',
    devicename: '所属设备',
    door: '所属门(闸)',
    remark: '备注',
  },
  devicegroup: {
    unionid: '联动组',
    devicegroupsn: 'SN',
    devicegroupname: '权限组',
    title: '权限组设置',
    add: '新增',
    edit: '修改',
    delete: '删除',
    cda: '创建时间',
    mda: '修改时间',
    remark: '备注',
  },
  subdevice: {
    ip: 'IP地址',
    brandname: '硬件协议',
    brandid: '硬件协议',
    title: '从设备管理',
    add: '新增',
    edit: '修改',
    delete: '删除',
    cda: '创建时间',
    mda: '修改时间',
    subdevicename: '从设备名称',
    subdevicetypeid: '从设备类型',
    address: '从设备地址',
    propertyid: '从设备属性',
  },
  liftdevice: {
    status_online: '状态',
    online: '在线',
    offline: '离线',
    brandname: '硬件协议',
    brandid: '硬件协议',
    id: '设备ID',
    pwdcontroltype: '密码方式',
    liftblock: '读写区块',
    serialnumber: '序列号',
    title: '设备管理',
    add: '新增',
    edit: '修改',
    delete: '删除',
    cda: '创建时间',
    mda: '修改时间',
    isvalid: '是否有效',
    version: '软件版本',
    devicename: '设备名称',
    ip: '设备IP',
    address: '设备地址',
    computerid: '连接电脑',
    buildid: '设备位置',
    repeatcalllifttimes: '重复呼梯次数',
    keydelay: '按键延时',
    visitordelay: '访客用梯延时',
    calloutcutofftime: '外呼最大切断时间',
    memorylevel: '记录区剩余空间报警',
    iswifi: '是否支持WIFI',
    isremote: '是否支持远程开门(闸)',
    wifiname: 'WIFI名称',
    wifipwd: 'WIFI密码',
    pwdtypeid: '密码方式',
    pwdnum: '密码次数',
    vipcutcallout: '贵宾卡切断外呼',
    longitude: '经度',
    latitude: '纬度',
  },
  header: {
    logOut: '退出系统'
  },
  keylog: {
    cardsn: '卡号',
    usertype: '用户类型',
    humtemp: '体温',
    devicename: '设备',
    usedtime: '刷卡时间',
    keysn: '卡号',
    cardtypeid: '卡类型',
    keytypeid: '卡类',
    status: '状态',
    devicegroup: '权限组',
    validdate: '有效时间',
    idcard: 'ID卡',
    avatar: '人脸',
    collecting: '',
    vein: '静脉',
    finger: '指纹',
    iccard: 'IC卡',
    messages: '结果',
    username: '用户名',
    mobile: '手机号',
    isvalid: '状态',
  },
  key: {
    keyid: '卡ID',
    date: '日期',
    tousername: '被访人姓名',
    tomobile: '被访人手机',
    addcpu: '添加CPU卡',
    addqr: '添加二维码',
    addic: '添加IC卡',
    addavatar: '添加人脸', 
    addfinger: '添加指纹卡',
    addid: '添加ID卡',
    addven: '添加静脉卡',
    isleave: '滞留',
    edit: '编辑',
    add: '新增',
    cda: '创建时间',
    mda: '修改时间',
    delete: '删除',
    keysn: '卡号',
    cardtypeid: '卡类型',
    keytypeid: '卡类',
    status: '状态',
    usertype: '用户类型',
    devicegroup: '权限组',
    validdate: '有效时间',
    idcard: 'ID卡',
    cpucard: 'CPU卡',
    avatar: '人脸',
    collecting: '',
    vein: '静脉',
    finger: '指纹',
    iccard: 'IC卡',
    qrcode: '二维码',
    messages: '结果',
    username: '用户名',
    mobile: '手机号',
    isvalid: '状态',
    liftusedtimes: '电梯使用次数',
    liftusedtime: '电梯使用时间',
    doorusedtimes: '门(闸)使用次数',
    doorusedtime: '门(闸)使用时间',
    doorvaliddate: '门(闸)有效时间',
    liftvaliddate: '电梯有效时间',
    doordevicegroups: '门(闸)权限组',
    liftdevicegroups: '电梯权限组',
  },
  holiday: {
    title: '节假日设置',
    add: '新增',
    edit: '修改',
    delete: '删除',
    cda: '创建时间',
    mda: '修改时间',
    holidayname: '假期名称',
    userlevel: '用户级别',
    startday: '开始日期',
    endday: '截止日期',
    timeslotid: '时间时段',
    doorid: '有效门(闸)',
    door: '有效门(闸)',
    starttime: '开始时间',
    endtime: '截止时间',
    floor: '有效楼层',
  },
  opentime: {
    add: '新增',
    edit: '修改',
    delete: '删除',
    cda: '创建时间',
    mda: '修改时间',
    title: '开放时间设置',
    sectionid: '分段',
    starttime: '开始时间',
    endtime: '结束时间',
    floorid: '有效楼层',
    doorid: '有效门(闸)',
    timetypeid: '基础时段',
    dayid: '星期',
  },
  camera: {
    add: '新增',
    edit: '修改',
    delete: '删除',
    cda: '创建时间',
    mda: '修改时间',
    title: '摄像头设置',
    cameraname: '摄像头名称',
    cameratypeid: '类型',
    ip: 'IP地址',
  },
  download: {
    mobile: '手机号',
    username: '姓名',
    cardsn: '卡号',
    trynum: '尝试次数',
    devicename: '设备名称',
    systemtypeid: '所属系统',
    cda: '创建时间',
    mda: '修改时间',
    title: '下载数据',
    keysn: '卡号',
    keytypeid: '卡类型',
    optypeid: '操作类型',
    status: '状态',
    message: '消息',
    whitekeytitle: '白名单',
    blackkeytitle: '黑名单',
    timetypetitle: '基础时段',
    timeslottitle: '有效时段',
    devicegrouptitle: '权限分组',
    flooritle: '楼层',
    userlevel: '用户级别',
    devicetitle: '设备配置参数',
    subdevicetitle: '从设备配置',
  },
  door: {
    title: '门(闸)设置',
    longitude: '经度',
    latitude: '纬度',
    typeid: '门(闸)类型',
    position: '所属位置',
    buildname: '所属楼宇',
    buildcode: '楼宇代码',
    floorname: '所属楼层',
    roomname: '所属房号',
    add: '新增',
    edit: '修改',
    delete: '删除',
    cda: '创建时间',
    mda: '修改时间',
    deviceid: '所属设备',
    doorid: '所属门(闸)',
    doorsn: '门(闸)号',
    doorname: '门(闸)名称',
    opentypeid: '打开方式', // 0=>'常关',1 => '可进', 2 => '可出', 3 => '可进出'', 
    wifiname: 'wifi名称',
    wifipwd: 'wifi密码',
    outbutton: '按钮出',
    outcard: '巡更卡开',
    closecontrol: '关控制', // 0自动延时关门(闸) 1读卡关门(闸)',
    inriot: '进读头防暴锁',
    outriot: '出读头防暴锁',
    inchannel: '进通道锁',
    outchannel: '出通道锁',
    inreaderalarm: '进读头是否允许报警',
    inreadertypeid: '进读头数据格式',
    outreaderalarm: '出读头是否允许报警',
    outreadertypeid: '出读头数据格式',
    systemtypeid: '所属系统', // 1门(闸)系统 2通道闸系统',
    isalarm: '是否报警使能',
    statealarm: '状态报警',
    doortype: '门(闸)方式',
    identification: '身份识别',
    alarmenable: '报警使能：',
    openenable: '开门(闸)使能',
    autoclosecontrol: '关门(闸)控制',
    rulememorylevel: '权限组剩余容量报警门(闸)限',
    antisubmarine: '反潜控制',
  },
  device: {
    status_online: '状态',
    online: '在线',
    offline: '离线',
    brandid: '硬件协议',
    doorid: '所属门(闸)',
    doorname: '所属门(闸)',
    opentypeid: '打开方式', // 0=>'常关',1 => '可进', 2 => '可出', 3 => '可进出'', 
    brandname: '硬件协议', 
    price: '接入价',
    model: '型号',
    brand: '品牌',
    image: '图片',
    desc: '参数',
    id: '设备ID',
    title: '设备管理',
    add: '新增',
    edit: '修改',
    delete: '删除',
    cda: '创建时间',
    mda: '修改时间',
    isvalid: '是否有效',
    version: '软件版本',
    devicename: '设备名称',
    devicesn: '设备序号',
    address: '设备地址',
    serialnumber: '序列号',
    computerid: '连接电脑',
    devicegrouplimit: '权限组表剩余容量报警',
    recodelimit: '记录区剩余容量报警',
    blacklimit: '黑名单剩余容量报警',
    opendelaytime: '打开延时时间',
    closedelaybuzzertime: '未关时蜂鸣延时时间',
    closedelayalarmtime: '未关时报警延时时间',
    firealarmdealytime: '消防报警延时',
    riotalarmdealytime: '防暴报警延时',
    firealarm: '消防报警',
    riotalarm: '防暴报警',
    buzzeralarm: '蜂鸣器报警',
    alarmoutput: '报警器报警输出',
    inriot: '进读头防暴锁',
    outriot: '出读头防暴锁',
    inchannel: '进通道锁',
    outchannel: '出通道锁',
    remotevalidtime: '远程控制有效时长',
    memorylevel: '记录区剩余容量报警门(闸)限',
    blackmemorylevel: '黑名单剩余容量报警门(闸)限',
    ip: '相机IP',
    longitude: '经度',
    latitude: '纬度',
    useblock: '卡使用区',
  },

  lifttimeslot: {
    sectionid: '时段',
    timeslotname: '时间段名称',
    startday: '开始时间',
    endday: '截止时间',
    week: '休息日',
    add: '新增',
    edit: '修改',
    delete: '删除',
    cda: '创建时间',
    mda: '修改时间',
    timetype1: '时间段1',
    timetype2: '时间段2',
    timetype3: '时间段3',
    timetype4: '时间段4',
  },
  timeslot: {
    sectionid: '时段',
    timeslotname: '时间段名称',
    startday: '开始时间',
    endday: '截止时间',
    week: '周期',
    add: '新增',
    edit: '修改',
    delete: '删除',
    cda: '创建时间',
    mda: '修改时间',
  },
  timetype: {
    estatename: '社区名称',
    timetypename: '时间段',
    starttime: '开始时间',
    endtime: '截止时间',
    add: '新增',
    edit: '修改',
    delete: '删除',
    cda: '创建时间',
    mda: '修改时间',
  },
  importtb: {
    add: '上传文件',
    file: '文件',
    remark: '备注',
    download: '下载',
  },
  importrelation: {
    add: '上传文件',
    file: '文件',
    remark: '备注',
    download: '下载',
  },
  userlevel: {
    icon: '用户级别',
    title: '用户级别设置',
    levelname: '级别名称',
    add: '新增',
    edit: '修改',
    delete: '删除',
    cda: '创建时间',
    mda: '修改时间',
  },
  userapply: { 
    keysn: '卡号',
    keytypeid: '卡类型',
    managername: '审核人',
    bodypic: '全景照',
    applyremark: '申请原因',
    reviewremark: '审核结果',
    address: '地址',
    username: '姓名',
    mobile: '手机',
    idcard: '身份证',
    buildname: '所属楼宇',
    floorname: '所属楼层',
    roomcode: '所属房号',
    roomname: '房间名称',
    confirm: '审核', 
    cda: '申请时间',
    mda: '审核时间',
    sex: '性别',
    avatar: '头像',
    cardtypeid: '卡类型',
    validdate: '有效期限',
    userlevel: '用户级别',
    passwordlevel: '密码级别',
    isvalid: '状态',
    week: '休息日',
    usertype: '用户类型',
    liftdevicegroups: '电梯权限',
    doordevicegroups: '门(闸)权限',
    keys: '钥匙',  
    idcardfront: '身份证正面',
    idcardback: '身份证反面',
    remark: '备注',
    status: '审核状态',
    auditor: '审核人',
    touid: '被访问者',
    openid: '微信ID',
    tousername: '被访者',
    toavatar: '头像',
    tomobile: '手机号',
    
  },
  user: {
    icsn: 'IC卡',
    caneditmobile: '允许修改手机',
    caneditavatar: '允许修改头像',
    liftdevicetimes: '电梯次数',
    doordevicetimes: '门(闸)次数',
    isopen: '公开查询',
    address: '地址',
    username: '姓名',
    mobile: '手机',
    idcard: '身份证',
    status: '状态',
    buildname: '所属楼宇',
    floorname: '所属楼层',
    roomcode: '所属房号',
    roomname: '房间名称',
    add: '新增',
    edit: '修改',
    cda: '创建时间',
    mda: '修改时间',
    sex: '性别',
    avatar: '头像',
    cardtypeid: '卡类型',
    validdate: '有效期限',
    userlevel: '用户级别',
    passwordlevel: '密码级别',
    isvalid: '状态',
    week: '休息日',
    usertype: '用户类型',
    liftdevicegroups: '电梯权限',
    doordevicegroups: '门(闸)权限',
    keys: '钥匙',
  },
  floor: {
    title: '楼层设置',
    add: '新增楼宇',
    edit: '修改楼宇',
    cda: '创建时间',
    mda: '修改时间',
    estateid: '所属社区',
    estatename: '社区名称',
    buildname: '楼宇名称',
    floorcode: '楼层代码',
    floorname: '楼层名称',
    floorsn: '楼层序号',
    roomcode: '房号',
    roomtitle: '房间信息',
    roomname: '房名',
  },
  build: {
    title: '楼宇设置',
    add: '新增楼宇',
    edit: '修改楼宇',
    cda: '创建时间',
    mda: '修改时间',
    estateid: '所属社区',
    estatename: '社区名称',
    buildname: '楼宇名称',
    buildcode: '楼宇代码',
    buildunit: '单元代码',
    floornum: '楼层数',
    roomnum: '房间数',
    roomrule: '房号规则',
  },
  estate: {
    doorsetup: '门(闸)设置',
    uploadidcard: '上传身份证',
    title: '社区设置',
    add: '新增社区',
    edit: '修改社区',
    cda: '创建时间',
    mda: '修改时间',
    city: '所在城市',
    groupid: '所属集团',
    typeid: '类型',
    estatename: '社区名称',
    estatecode: '社区代码',
    linkman: '联系人',
    linktel: '联系电话',
    usedsystem: '使用系统',
    longitude: '经度',
    latitude: '纬度',
    groupname: '集团名称',
  },
  manager: { 
    roleids: '所属角色',
    levelid: '管理范围',
    rooms: '管理房间',
    title: '管理员设置',
    avatar: '头像',
    estatename: '所属社区',
    account: '登录账号',
    loginpwd: '密码',
    reloginpwd: '重复密码',
    mobile: '电话',
    add: '新增管理员',
    edit: '修改管理员',
    oldloginpwd: '原密码',
    newloginpwd: '新密码',
    changepwd: '修改密码',
    resetpwd: '重置密码',
    roleid: '所属角色',
    managername: '姓名',
    estateid: '所属社区',
    logintimes: '登陆次数',
    logindate: '登录时间',
    isrepwd: '是否重置密码',
    status: '状态',
    lasttime: '登录时间',
    lastip: '登录IP',
    cda: '创建时间',
    mda: '修改时间',
    groupid: '所属集团',
    manageestateids: '管理社区'
  },
  route: {
    DownloadList: '下载数据',
    CardKeyLogList: '刷卡记录',
    PayOrderList: '订单查询',
    UserDetailList: '会员管理',
    CardTitle: '消费卡管理',
    CardTypeList: '卡类型管理',
    UserCardList: '会员卡管理',
    MonitorMap: '地图管理',
    MonitorTitle: '地图管理',
    TalkBackList: '楼宇对讲',
    WorkTitle: '考勤管理',
    PlanList: '排班管理',
    ReportList: '考勤报表',
    ComputeList: '考勤核算',
    HandsignList: '手工签到',
    SchedulingList: '班次时段',
    OffdutyList: '离岗管理',
    UserDisabledList: '用户注销',
    DoorLogSumTotal: '开门统计',
    LiftLogSumTotal: '开梯统计',
    ReportTitle: '报表查询',
    KeyQuery: '钥匙查询', 
    VisitorBodyPicApply: '自助审核',
    VisitorApplyTotal: '访客申请统计',
    UserApplyTotal: '用户申请统计',
    LiftLog: '开梯记录',
    DoorLog: '开门记录',
    RoomSum: '按房号统计',
    UserBlackList: '黑名单管理',
    BaseManagerList: '管理员管理',
    VisitorApply: '访客申请',
    VisitorTitle: '访客系统',
    VisitorCreate: '新增访客',
    VisitorKeyList: '访客查询',
    VisitorStayList: '滞留查询',
    BaseDoorList: '门(闸)设置',
    DoorTitle: '门(闸)系统',
    LiftTitle: '梯控系统',
    TalkbackTitle: '楼宇对讲',
    SysTitle: '系统设置',
    index: '首页',
    operatorLogIndex: '操作日志查询',
    Query: '统计查询',
    PageTitle: '布局设置',
    PageLayoutList: '页面布局',
    BaseTitle: '基础设置',
    BaseEstateList: '社区设置',
    BaseRoleList: '角色设置',
    UserTitle: '用户管理',
    UserBaseList: '用户开卡',
    UserApplyList: '用户审核',
    UserLevelList: '用户级别',
    TimeTypeList: '基础时段',
    TimeSlotList: '时间段设置',
    HolidayList: '假日设置',
    KeyBaseList: '钥匙查询',
    KeyBaseManage: '钥匙管理',
    KeyLogList: '通行记录',
    KeyTitle: '钥匙管理',
    DeviceList: '设备设置',
    TwoDeviceList: '分体设备',
    OneDeviceList: '一体设备',
    DeviceGroupList: '权限组设置',
    dashboard: '首页',
    introduction: '简述',
    icons: '图标',
    components: '组件',
    componentIndex: '介绍',
    countTo: 'CountTo',
    componentMixin: '小组件',
    backToTop: '返回顶部',
    tab: 'Tab',
    form: '表单',
    errorPages: '错误页面',
    page401: '401',
    page404: '404',
    errorLog: '错误日志',
    excel: 'Excel',
    theme: '换肤',
    clipboardDemo: 'Clipboard',
    i18n: '国际化',
  },
  role: {
    manager: '授权',
    estateid: '所属社区',
    menu: '权限',
    ispublic: '是否公用',
    rolename: '角色名称',
    remark: '备注',
    id: '角色编号',
    edit: '角色修改',
    add: '角色新增',
    right: '权限设置'
  },
  table: {
    import: '导入',
    save: '保存',
    download: '下载',
    selectAll: '全部',
    selectBack: '选择返回',
    changestatus: '修改状态',
    select: '选择',
    dragTips1: '默认顺序',
    dragTips2: '拖拽后顺序',
    title: '标题',
    importance: '重要性',
    type: '类型',
    remark: '点评',
    search: '搜索',
    add: '添加',
    export: '导出',
    reviewer: '审核人',
    id: '序号',
    date: '时间',
    author: '作者',
    readings: '阅读数',
    status: '状态',
    actions: '操作',
    edit: '编辑',
    deal: '处理',
    publish: '发布',
    draft: '草稿',
    delete: '删除',
    cancel: '取 消',
    confirm: '审核',
    right: '授权',
    query: '查询',
    submit: '提交',
    index: '序号',
    detail: '详情',
    close: '关闭',
    view: '详情',
    reviews: '审核'
  },
  errorLog: {
    tips: '请点击右上角bug小图标',
    description: '现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。',
    documentation: '文档介绍'
  },
  theme: {
    change: '换肤',
    documentation: '换肤文档',
    tips: 'Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。'
  },
  tagsView: {
    refresh: '刷新',
    close: '关闭',
    closeOthers: '关闭其它',
    closeAll: '关闭所有'
  },
  public: {
    select: '请选择',
    gtZerroNumber: '大于0',
    minZerroNumber: '正数',
    intNumber: '整数',
    pleaseEnter: '请输入',
    pleaseSelect: '请选择',
    between_0_100: '不能小于0或大于100',
    lessthan0: '不能小于0',
    number: '数字',
    addSuccess: '新增成功',
    editSuccess: '修改成功',
    confirmSuccess: '审核成功',
    deleteSuccess: '删除成功',
    operate: '设置操作',
    confirm: '审核',
  },
  navbar: {
    logOut: '退出登录',
    dashboard: '首页',
    github: '社区地址',
    screenfull: '全屏',
    theme: '换肤',
    size: '布局大小'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/zh.js